<template>
    <div class="manage-content">
        <div class="location">达人管理中心 / 代客下单</div>
        <div class="white-bg shadow margin-top-20 padding30 radius relative">
            <el-button type="primary" size="small" class="anentReleaseBtn absolute" @click="gotoRelease">立即下单</el-button>
            <el-tabs v-model="activeType" @tab-click="handleClick">
                <el-tab-pane label="待付款" name="3">
                    <agent-tab1 :list="list"
                                :orderTotal="orderTotal"
                                :currentPage="currentPage"
                                @func="cancel"
                                @changCurrent='changPage'></agent-tab1>
                </el-tab-pane>
                <el-tab-pane label="进行中" name="1">
                    <agent-tab2 :list="list"
                                :orderTotal="orderTotal"
                                :currentPage="currentPage"
                                @func="cancel"
                                @changCurrent='changPage'></agent-tab2>
                </el-tab-pane>
                <el-tab-pane label="待审核" name="0">
                    <agent-tab3 :list="list"
                                :orderTotal="orderTotal"
                                :currentPage="currentPage"
                                @func="cancel"
                                @changCurrent='changPage'></agent-tab3>
                </el-tab-pane>
                <el-tab-pane label="已完成" name="2">
                    <agent-tab4 :list="list"
                                :orderTotal="orderTotal"
                                :currentPage="currentPage"
                                @func="cancel"
                                @changCurrent='changPage'></agent-tab4>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import {agentTaskList,taskCancel,getAgentEp} from '@/config/api.js'
    import agentTab1 from './components/tab1'
    import agentTab2 from './components/tab2'
    import agentTab3 from './components/tab3'
    import agentTab4 from './components/tab4'
    export default {
        name: 'DarenValet',
        inject:['reload'],
        provide(){
            return{
                getOrder:this.getOrder
            }
        },
        components: {agentTab1,agentTab2,agentTab3,agentTab4},
        data () {
            return {
                activeType: String(this.$store.state.darenOrderTab),
                list: [],
                orderTotal: 0,
                currentPage: 1,
            }
        },
        methods: {
            handleClick (tab) {
                this.getOrder();
                this.$store.commit('changeDarenOrderTab',tab.paneName);
            },
            changPage(val){
                this.currentPage = val;
            },
            getOrder () {
                let data = {
                    user_type: 0,
                    page: this.currentPage - 1,
                    agent_id: this.$store.state.user_id,
                    type: this.activeType
                };
                this.$post(agentTaskList,data)
                    .then(res => {
                        const data = res.data;
                        this.list = data.list;
                        this.orderTotal = Number(data.count);
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            },
            cancel (id,user_id) {
                this.$confirm('确认要取消该任务吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        user_type: this.$store.state.user_type,
                        task_id: id,
                        user_id: user_id,
                    };
                    this.$post(taskCancel,data)
                        .then(res => {
                            this.$message.success(res.msg);
                            this.reload()
                        })
                        .catch(err => {
                            this.$message.error(err.msg)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            epList () {
                let data = {
                    agent_id:this.$store.state.user_id
                };
                this.$post(getAgentEp,data)
                    .then( res => {
                        window.console.log(res)
                    })
            },
            gotoRelease () {
                this.$router.push('/daren/release')
            }
        },
        computed: {
            listCon () {
                return this.list
            }
        },
        watch: {
            list (val) {
                this.list = val
            }
        },
        created() {
            this.getOrder();
        }
    }
</script>
<style scoped>
    .anentReleaseBtn{right:30px;top:30px;z-index: 99;}
</style>
